import { APIPaths } from "../common/constants";
import useToken from "../common/helper/usetoken";
import interceptor from "../common/interceptor/interceptor";

// Sign Up form
export const SignUpUser = (model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosLogin("Post",`/auth/register/?is_signup=true`, model, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })

    });
};

//Email Verify
export const GetEmailVerified = (id) => {
    return new Promise((resolve, reject) => {
        let path = `/auth/verify-email/${id}`;
        interceptor.axiosLogin("Get", path,null, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })

    });
};


export const CreatePasswordApi = (model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosLogin("Post", "/auth/set-password/", model, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })

    });
};


// Login In form
export const Login = (model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosLogin("Post", "/auth/login/", model, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })

    });
};

export const Refresh = (model) => {

    return new Promise((resolve, reject) => {
        interceptor.axiosLogin("Post", "/auth/login/refresh/", model, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })

    });
};
export const ForgotPasswordApi = (email) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosLogin(
            "Post", 
            "/auth/forgot-password/", 
            { email }, 
            null
        )
        .then(res => resolve(res))
        .catch(error => {
            console.error("API Error:", error?.response);
            reject(error?.response);
        });
    });
};


// API call for Get permissions menu
export const GetMenu = (token) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosGet("Get", APIPaths.get_menu, token, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })
    });
};



